import { createTelemetryAPI } from '~/utils/telemetry'

export const clustersTelemetry = createTelemetryAPI(({ track }) => ({
  search() {
    return track('All Clusters: Search')
  }
}))
